module.exports = __webpack_public_path__ + "img/sz.287333f4.svg";